var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useRef, useState, } from "react";
import { connect } from "./index";
import { InternalMessageEventType } from "./WebgateConnect";
const WebgateContext = createContext({});
export const WebgateProvider = ({ portalUrl, context, children, }) => {
    const [accessToken, setAccessToken] = useState(context === null || context === void 0 ? void 0 : context.accessToken);
    const [initialized, setInitialized] = useState(!!(context === null || context === void 0 ? void 0 : context.initialized));
    const [pathname, setPathname] = useState();
    const [userInfo, setUserInfo] = useState();
    const portalConnect = useRef();
    useEffect(() => {
        portalConnect.current = connect({
            portalUrl,
        });
        portalConnect.current.on(InternalMessageEventType.NEW_ACCESS_TOKEN, (token) => {
            setAccessToken(token);
            setInitialized(true);
        });
        portalConnect.current.on(InternalMessageEventType.LOCATION_CHANGED, (location) => {
            setPathname(location);
        });
        portalConnect.current.on(InternalMessageEventType.INITIALIZED, setInitialized);
        portalConnect.current
            .getAccessToken()
            .then((token) => __awaiter(void 0, void 0, void 0, function* () {
            setAccessToken(token);
            setInitialized(true);
        }))
            .catch(() => null);
    }, [portalUrl]);
    useEffect(() => {
        var _a;
        if (!accessToken) {
            return;
        }
        (_a = portalConnect.current) === null || _a === void 0 ? void 0 : _a.getUserInfo().then(setUserInfo);
    }, [accessToken]);
    return (_jsx(WebgateContext.Provider, Object.assign({ value: {
            initialized,
            accessToken,
            userInfo,
            pathname,
            serverData: context === null || context === void 0 ? void 0 : context.serverData,
            portalConnect: portalConnect.current,
        } }, { children: children })));
};
export function useWebgate() {
    return useContext(WebgateContext);
}
